import { useEffect, useRef } from 'react';

import { fg } from '@confluence/feature-gating';

import {
	STEPS,
	useSetModernizeChangeboardingOnboardingState,
} from './useModernizeChangeboardingOnboardingState';

export const useExcludeFromModernizeGAChangeboarding = (skip: boolean = false) => {
	const { completeSegments } = useSetModernizeChangeboardingOnboardingState();
	const hasCompleted = useRef(false);

	useEffect(() => {
		if (skip || !fg('cc_modernize_ga_changeboarding') || hasCompleted.current) {
			return;
		}

		completeSegments([
			STEPS.NAV_4_GLOBAL,
			STEPS.NAV_4_SPACE,
			STEPS.LIVE_DOC,
			STEPS.CONVERT_TO_PAGE,
			STEPS.CONTENT_WRAPPER,
		]);
		hasCompleted.current = true;
	}, [completeSegments, skip]);
};
